export const hasRotation = (theme, rotation) => ({
    transform: `rotate(${rotation}deg)`,
    transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
    }),
});
export const spaceBetween = {
    display: "flex",
    justifyContent: "space-between",
};
export const SelectStyle = {
    menu: (styles) => Object.assign(styles, { zIndex: 1000, heigth: 100 }),
};
export const myColors = {
    scans: "#75e8ad",
    reports: "#139fe5",
    alerts: "#9d0050",
};
//# sourceMappingURL=StyleUtils.js.map